import { observer } from "mobx-react-lite";

import { ColourSelectField } from "@ui-components/form/selects/ColourSelectField.tsx";

import { LocationLabels } from "../PracticeScreen.types.ts";
import { locationFormNameOf } from "./LocationDetails.types.ts";
import { LocationDetailsFormFieldLabel } from "./LocationDetailsFormFieldLabel.tsx";

const COLOUR_SELECT_DESCRIPTION =
  "Used to identify location on appointment book";
export const MultiLocationsFields = observer(() => {
  return (
    <ColourSelectField
      placeholder={LocationLabels.selectColor}
      name={locationFormNameOf("appointmentBookMarker")}
      onRenderLabel={props => (
        <LocationDetailsFormFieldLabel
          disabled={props?.disabled}
          label={LocationLabels.selectColor}
          tooltip={COLOUR_SELECT_DESCRIPTION}
          nameOfField="appointmentBookMarker"
        />
      )}
    />
  );
});
